import JsonView from "@uiw/react-json-view";
import React, {useMemo} from "react";
import PropTypes from "prop-types";

const PayloadJSONView = ({
  payload,
  collapsed = false,
  displayDataTypes = false,
  displayObjectSize = false,
  objectSortKeys,
}) => {
  let parsedPayload;
  try {
    parsedPayload = JSON.parse(payload);
  } catch (e) {
    return payload;
  }

  const sortKeys = useMemo(() => {
    if (objectSortKeys !== undefined) {
      return objectSortKeys;
    }

    return (keyA, keyB, valueA, valueB) => {
      if (keyA === "id") return -1;
      if (keyB === "id") return 1;
      if (valueA !== null && valueB !== null && typeof valueA === "object" && typeof valueB !== "object") return 1;
      if (valueA !== null && valueB !== null && typeof valueA !== "object" && typeof valueB === "object") return -1;
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 1;
    }
  }, [objectSortKeys])

  return <JsonView
    value={parsedPayload}
    displayDataTypes={displayDataTypes}
    displayObjectSize={displayObjectSize}
    collapsed={collapsed}
    objectSortKeys={sortKeys}
  >
    {/*Do not display array index*/}
    <JsonView.Colon render={(props, { parentValue }) => {
      if (Array.isArray(parentValue) && props.children == ":") {
        return <span />
      }
      return <span {...props} />
    }}/>
    <JsonView.KeyName
      render={({ ...props }, { type, parentValue }) => {
        if (Array.isArray(parentValue) && Number.isFinite( props.children)) {
          return <span />
        }
        return <span {...props} />
      }}
    />
    {/*Show null value in visualization with disabled types*/}
    <JsonView.Null
      render={(props, { type, value }) => {
        if (!displayDataTypes && type === 'value') {
          return <span {...props}>{String(value)}</span>
        }
      }}
    />
    {/*Show NaN value in visualization with disabled types*/}
    <JsonView.Nan
      render={(props, { type, value }) => {
        if (!displayDataTypes && type === 'value') {
          return <span {...props}>{String(value)}</span>
        }
      }}
    />

  </JsonView>
};

PayloadJSONView.propTypes = {
  payload: PropTypes.string.isRequired,
  collapsed: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number
  ]),
  displayDataTypes: PropTypes.bool,
  displayObjectSize: PropTypes.bool,
  objectSortKeys: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func
  ]),
};

export default PayloadJSONView;
